// @ts-nocheck
/**
 * 统一日志工具
 *
 * - 开发环境显示调试日志
 * - 生产环境仅保留 warn/error
 */

const isDev = process.env.NODE_ENV === 'development';

function formatPrefix(level: string): string {
  const timestamp = new Date().toISOString().split('T')[1].slice(0, 8);
  return `[${timestamp}] [${level}]`;
}

export const logger = {
  log: (...args: any[]) => {
    if (isDev) {
      console.log(formatPrefix('LOG'), ...args);
    }
  },

  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(formatPrefix('DEBUG'), ...args);
    }
  },

  info: (...args: any[]) => {
    if (isDev) {
      console.info(formatPrefix('INFO'), ...args);
    }
  },

  warn: (...args: any[]) => {
    console.warn(formatPrefix('WARN'), ...args);
  },

  error: (...args: any[]) => {
    console.error(formatPrefix('ERROR'), ...args);
  },

  group: (label: string) => {
    if (isDev) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDev) {
      console.groupEnd();
    }
  },

  table: (data: any) => {
    if (isDev) {
      console.table(data);
    }
  },
};

export default logger;
